
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import { Helmet } from 'react-helmet-async';

const Team = () => {
  const [openStates, setOpenStates] = useState<{ [key: string]: boolean }>({});
  
  const team = [
    {
      name: "Dalya Hockman",
      role: "Registered Dietitian",
      description: "Expert in weight management and chronic disease prevention.",
      fullBio: "Dalya Hockman is a Registered Dietitian and owner of Functional Foodie Registered Dietitians. She completed her Bachelor of Dietetics at the University of Pretoria and is an Eatfit IBS (Irritable Bowel Syndrome) accredited dietitian. Dalya is passionate about helping people achieve their health goals, whether it is weight loss, weight gain, management of a chronic illness, or simply improving their overall wellness. Dalya believes that everyone deserves to enjoy a delicious and nutritious meal, and strives to make that a reality for her clients.\nDalya has experience working with people of all ages and with a variety of health concerns. She provides one-on-one nutrition counselling, and works with her clients to create a plan that best fits their lifestyle and food preferences.\nAs a  foodie Dalya is constantly experimenting with new recipes and ingredients to find the perfect combination of taste and nutrition. She always incorporates her favourite foods into her lifestyle and loves to show her clients how they can do this too!\nWith her vast experience with both adult and paediatric clients, Dalya can definitely assist with your dietary needs.",
      image: "/lovable-uploads/c0deae8b-0f07-44d0-a513-2c786f52b3e7.png"
    },
    {
      name: "Ron Neuman",
      role: "Registered Dietitian",
      description: "Focused on holistic nutrition and lifestyle management.",
      fullBio: "Ron Neuman is a registered dietitian renowned for her holistic approach to nutrition and lifestyle management. She holds a bachelor's degree in Dietetics from the University of the Western Cape and has experience working in various healthcare settings.\nThroughout her career, Ron has provided care in surgical wards, ICU wards, antenatal and postnatal wards, psychiatric wards, medical wards, and pediatric wards, demonstrating her versatility in addressing the needs of diverse patient populations.\nWith a deep passion for helping individuals achieve optimal health, Ron focuses on empowering her clients through personalized dietary and lifestyle interventions. She is passionate working with chronic diseases of lifestyle, weight loss, and emotional eating, advocating for a comprehensive approach that encompasses all aspects of well-being.\nIn addition to her clinical work, Ron is a foodie who delights in exploring culinary creativity and global cuisines. She enjoys crafting new recipes and celebrating the cultural diversity of food.\nWith her expertise in nutrition and her genuine love for food, Ron is dedicated to guiding individuals on their journey to a healthier and happier life.",
      image: "/lovable-uploads/a5d84dbb-d943-44c2-82ae-4698ff3f2e72.png"
    },
  ];

  const toggleBio = (name: string) => {
    setOpenStates(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  return (
    <>
      <Helmet>
        <title>Meet Our Expert Dieticians | Functional Foodie</title>
        <meta 
          name="description" 
          content="Learn more about our experienced dieticians at Functional Foodie. Get personalised nutrition advice from our expert team in Johannesburg. Meet your dietician today!"
        />
      </Helmet>
      <div className="min-h-screen bg-[#85a3a6] pt-64 pb-16">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">Meet Our Team</h1>
          <p className="text-lg text-center text-gray-600 mb-24 max-w-2xl mx-auto">
            Our experienced dietitians are here to guide you on your journey to better health through personalized nutrition.
          </p>
          
          <div className="space-y-16">
            {team.map((member, index) => (
              <div key={member.name} className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
                <div className={`flex flex-col ${member.name === "Ron Neuman" ? "md:flex-row-reverse" : "md:flex-row"} gap-8 items-center`}>
                  {member.name === "Ron Neuman" ? (
                    <>
                      <div className="flex-1 space-y-6">
                        <div>
                          <h2 className="text-3xl md:text-4xl font-bold mb-2">
                            About <span className="text-secondary">{member.name}</span>
                          </h2>
                          <p className="text-xl text-primary font-semibold mb-6">{member.role}</p>
                        </div>
                        
                        <div className="text-gray-600 space-y-4">
                          {member.fullBio.split('\n').map((paragraph, index) => (
                            <p key={index} className="leading-relaxed">{paragraph}</p>
                          ))}
                        </div>
                      </div>
                      
                      <div className="md:w-[400px] md:h-[400px] w-[300px] h-[300px] flex-shrink-0">
                        <div className="w-full h-full rounded-full overflow-hidden border-4 border-accent shadow-xl">
                          <img 
                            src={member.image} 
                            alt={member.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex-1 space-y-6">
                        <div>
                          <h2 className="text-3xl md:text-4xl font-bold mb-2">
                            About <span className="text-secondary">{member.name}</span>
                          </h2>
                          <p className="text-xl text-primary font-semibold mb-6">{member.role}</p>
                        </div>
                        
                        <div className="text-gray-600 space-y-4">
                          {member.fullBio.split('\n').map((paragraph, index) => (
                            <p key={index} className="leading-relaxed">{paragraph}</p>
                          ))}
                        </div>
                      </div>
                      
                      <div className="md:w-[400px] md:h-[400px] w-[300px] h-[300px] flex-shrink-0">
                        <div className="w-full h-full rounded-full overflow-hidden border-4 border-accent shadow-xl">
                          <img 
                            src={member.image} 
                            alt={member.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Team;
